<template>
    <div class="copyRight">
        <div>
            <img src="../../img/celc_logo.png" alt="" class="logo">
        </div>
        <div class="footerMessage">
            主办单位：中外语言交流合作中心
        </div>
        <div class="footerMessage">
            <span>
            地址：北京市西城区德胜门外大街<span  class="num">129</span>号 邮编: <span  class="num">100088</span></span>
        </div>
        <div>
            <div  class="footerMessage">
        版权所有： 中外语言交流合作中心  <a  href="http://beian.miit.gov.cn">京ICP 备 <span class="num">08002516-8</span></a></div>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.copyRight {
    // position: absolute;
    bottom: 0px;
    left: 0;
    text-align: center;
    color: #a38fe9;
    margin-top: .6rem;
    right: 0;
    margin: .6rem auto 0;
    background-color: #031e5d;
    padding: .8rem 0;
    color: hsla(0,0%,100%,.6);
    font-size: .14rem;
    .logo {
        width: 1.3rem;
        margin: 0 auto .6rem;
    }
    .footerMessage {
        margin-bottom: .25rem;
        a {
            color: #c9bc9c;
        }
    }
}
</style>
